<template lang="html">
  <div>
    <div v-bind:key="muse.id" v-for="muse in music">
      <iframe :src="muse.src"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "music",
  props: ["music"]
}
</script>

<style lang="css" scoped>
  iframe {
    border: 0;
    width: 100%;
    max-width: 660px;
    min-width: 300px;
    background: transparent;
  }
</style>
